import React from 'react';
import ErrorPage from 'src/components/ErrorPage';
import PropTypes from 'prop-types';

const SomethingWentWrongView = ({ message, ...rest }) => {
  const serverDownIcon = 'https://nsdstaticasset.blob.core.windows.net/assets/Platform_Status_Images/500.png';
  return (
    <ErrorPage
      title='Something Went Wrong'
      // header='Server Error'
      message={message}
      imgSrc={serverDownIcon}
      imgAlt='Something Went Wrong'
      {...rest}
    />
  );
};

SomethingWentWrongView.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};


export default SomethingWentWrongView;
